import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from '@monorepo-channels/shared/util-environments'
import { Observable } from 'rxjs'
import {
	CreateSignupCodeDto,
	CreateSignupCodeResponse,
	ResendSignupCodeDto,
	ResendSignupCodeResponse,
	ConfirmSignupCodeDto,
	ConfirmSignupCodeResponse,
	LoginDto,
	LoginResponse,
} from './sign-up.model'

@Injectable()
export class AuthService {
	private http = inject(HttpClient)
	private baseURL = `${environment.channelsAPIURL}/api/v1/clients/authenticate`
	private authURL = `${environment.channelsAPIURL}/api/v1/auth`

	createSignupCode(dto: CreateSignupCodeDto): Observable<CreateSignupCodeResponse> {
		return this.http.post<CreateSignupCodeResponse>(`${this.baseURL}/createReceiveCode`, dto)
	}

	resendSignupCode(dto: ResendSignupCodeDto): Observable<ResendSignupCodeResponse> {
		return this.http.post<ResendSignupCodeResponse>(`${this.baseURL}/sendValidationCode`, dto)
	}

	confirmSignupCode(dto: ConfirmSignupCodeDto): Observable<ConfirmSignupCodeResponse> {
		return this.http.post<ConfirmSignupCodeResponse>(`${this.authURL}/confirmSignupCode`, dto)
	}

	loginCPF(dto: LoginDto): Observable<LoginResponse> {
		return this.http.post<LoginResponse>(`${this.baseURL}/loginCpf`, dto)
	}
}
